/* ==========================================================================
   Carrinho Ethos — lógica do drawer
   - Interceptor de fetch: qualquer mudança no carrinho agenda reconcile()
   - reconcile(): brinde automático (add/remove/qty=1) + re-render via Booster
   - Upsell: delegação no document (o DOM do drawer é descartável)
   - Confete 1x/sessão ao completar as metas
   - Checkout: handoff Yampi (opcionalmente removendo o brinde antes)
   Config: window.EthosCartConfig (snippets/cart-extras-config.liquid).
   Tudo falha em silêncio — carrinho quebrado é venda perdida.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.EthosCartConfig || {};
  var rawFetch = window.fetch.bind(window);
  // a IIFE do óculos de R$ 1 precisa do fetch CRU: mutações feitas dentro do
  // reconcile não podem reagendar outro reconcile (laço infinito)
  window.EthosCartRaw = rawFetch;

  /* ---------- Interceptor ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)/;
  var SUGGEST_RE = /search\/suggest\.json/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/add/.test(url)) maybeQueueCase(input, init);
    var p = rawFetch(input, init);
    if (CART_RE.test(url)) {
      p.then(schedule, schedule); // sucesso OU erro: reconciliar do mesmo jeito
    }
    if (SUGGEST_RE.test(url)) return filterSuggest(p);
    return p;
  };

  /* ---------- Busca instantânea: esconder produtos de campanha ----------
     Os clones do óculos de R$ 1 precisam ficar ativos e compráveis (a Yampi não
     promove produto inativo), mas se aparecerem na busca alguém compra um por
     R$ 129,90 sem a promoção. A grade de coleção e a página de busca filtram
     pela tag 'oculto' no Liquid; aqui não dá: /search/suggest.json não devolve
     tags, e o tema carrega booster.min.js, então o render não é editável.
     Resta filtrar pelo prefixo do handle. Qualquer falha devolve a resposta
     original — busca quebrada é pior do que um clone aparecendo. */
  var HIDDEN_HANDLE_RE = /\/products\/aniversario-r1-/;
  function filterSuggest(promise) {
    return promise.then(function (res) {
      try {
        if (!res || !res.ok || typeof Response === 'undefined') return res;
        return res.clone().json().then(function (data) {
          var r = data && data.resources && data.resources.results;
          if (!r || !r.products || !r.products.length) return res;
          var kept = r.products.filter(function (p) {
            return !HIDDEN_HANDLE_RE.test(p.url || '');
          });
          if (kept.length === r.products.length) return res;
          r.products = kept;
          return new Response(JSON.stringify(data), {
            status: res.status,
            statusText: res.statusText,
            headers: { 'Content-Type': 'application/json' }
          });
        }).catch(function () { return res; });
      } catch (e) {}
      return res;
    });
  }

  /* ---------- Case protetora: add junto com o produto principal (PDP) ---------- */
  var pendingCaseAdd = false;

  function extractVariantIds(body) {
    var ids = [];
    try {
      if (!body) return ids;
      if (typeof body === 'string') {
        try {
          var j = JSON.parse(body);
          if (j.items) j.items.forEach(function (it) { ids.push(parseInt(it.id, 10)); });
          else if (j.id) ids.push(parseInt(j.id, 10));
        } catch (e) {
          var sp = new URLSearchParams(body);
          if (sp.get('id')) ids.push(parseInt(sp.get('id'), 10));
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('id')) ids.push(parseInt(body.get('id'), 10));
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        if (body.get('id')) ids.push(parseInt(body.get('id'), 10));
      }
    } catch (e) {}
    return ids.filter(function (n) { return n > 0; });
  }

  function maybeQueueCase(input, init) {
    try {
      var el = document.querySelector('[data-cx-case][data-main-variants]');
      if (!el) return;
      var toggle = el.querySelector('[data-cx-case-toggle]');
      if (!toggle || !toggle.checked) return;
      var caseId = parseInt(el.getAttribute('data-case-variant'), 10);
      var mains = el.getAttribute('data-main-variants') || '';
      var body = init && init.body;
      if (!body && input && typeof input !== 'string' && input.clone) return; // Request object sem init: raro, ignora
      var ids = extractVariantIds(body);
      for (var i = 0; i < ids.length; i++) {
        if (ids[i] !== caseId && mains.indexOf(',' + ids[i] + ',') !== -1) {
          pendingCaseAdd = true;
          return;
        }
      }
    } catch (e) {}
  }

  function caseLogic(cart) {
    if (!pendingCaseAdd) return Promise.resolve();
    pendingCaseAdd = false;
    try {
      var caseEl = document.querySelector('[data-cx-case][data-main-variants]');
      var caseId = caseEl ? parseInt(caseEl.getAttribute('data-case-variant'), 10) : 0;
      if (!caseId) return Promise.resolve();
      var has = (cart.items || []).some(function (i) { return i.variant_id === caseId; });
      if (has) return Promise.resolve();
      return rawFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: caseId, quantity: 1 }] })
      }).catch(function () {});
    } catch (e) {}
    return Promise.resolve();
  }

  var timer = null;
  var busy = false;
  var pending = false;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 400);
  }

  function run() {
    if (busy) { pending = true; return; } // nunca descarta: re-agenda
    busy = true;
    reconcile()
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  /* ---------- Reconcile ---------- */
  function reconcile() {
    return rawFetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return giftLogic(cart).then(function () {
          return caseLogic(cart);
        }).then(function () {
          return r1Hook(cart);
        }).then(function () {
          return refresh().then(function () {
            confettiCheck();
            enhanceUpsell();
            syncDrawerOpen();
            setTimeout(syncDrawerOpen, 400); // drawer pode abrir logo após o refresh
          });
        });
      });
  }

  /* ---------- Óculos por R$ 1: ponte para a IIFE da campanha ----------
     Fica aqui para usar o pipeline único do reconcile (uma leitura de /cart.js,
     um re-render), mas a lógica vive isolada no fim do arquivo. */
  function r1Hook(cart) {
    try {
      if (window.EthosR1 && typeof window.EthosR1.reconcile === 'function') {
        return Promise.resolve(window.EthosR1.reconcile(cart)).catch(function () {});
      }
    } catch (e) {}
    return Promise.resolve();
  }

  function refresh() {
    try {
      if (window.BoosterTheme && BoosterTheme.cart && BoosterTheme.cart.dispatchListeners) {
        return Promise.resolve(BoosterTheme.cart.dispatchListeners({ change: true })).catch(function () {});
      }
    } catch (e) {}
    return Promise.resolve();
  }

  /* ---------- Brindes automáticos por nível ----------
     cfg.gifts = [{id: variantId, min: centavos}, ...]
     cumulativo: todos os níveis atingidos entram; senão só o nível mais alto. */
  function giftLogic(cart) {
    if (!cfg.giftEnabled || !cfg.gifts || !cfg.gifts.length) return Promise.resolve(false);
    try {
      var giftIds = cfg.gifts.map(function (g) { return g.id; });
      var giftLines = {};
      var paid = 0;
      (cart.items || []).forEach(function (item) {
        if (giftIds.indexOf(item.variant_id) !== -1) giftLines[item.variant_id] = item;
        else paid += item.final_line_price;
      });

      var eligible = cfg.gifts.filter(function (g) { return paid >= g.min; });
      var desired = [];
      if (eligible.length) {
        desired = cfg.giftCumulative
          ? eligible
          : [eligible.reduce(function (a, b) { return a.min >= b.min ? a : b; })];
      }
      var desiredIds = desired.map(function (g) { return g.id; });

      // operações em sequência: mutações concorrentes no carrinho se atropelam
      var ops = [];
      Object.keys(giftLines).forEach(function (vidStr) {
        var vid = parseInt(vidStr, 10);
        var line = giftLines[vid];
        if (desiredIds.indexOf(vid) === -1) ops.push(function () { return changeGift(line.key, 0); });
        else if (line.quantity !== 1) ops.push(function () { return changeGift(line.key, 1); });
      });
      var toAdd = desired.filter(function (g) { return !giftLines[g.id]; });
      if (toAdd.length) {
        ops.push(function () {
          showGiftPlaceholder();
          return rawFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: toAdd.map(function (g) { return { id: g.id, quantity: 1 }; }) })
          }).catch(function () {}).finally(hideGiftPlaceholder);
        });
      }
      if (!ops.length) return Promise.resolve(false);
      return ops.reduce(function (chain, op) {
        return chain.then(op).catch(function () {});
      }, Promise.resolve()).then(function () { return true; });
    } catch (e) {}
    return Promise.resolve(false);
  }

  function changeGift(key, qty) {
    return rawFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return true; }).catch(function () { return false; });
  }

  function showGiftPlaceholder() {
    try {
      var entries = document.querySelector('.cx-entries');
      if (!entries || entries.querySelector('.cx-gift-placeholder')) return;
      var el = document.createElement('div');
      el.className = 'cx-gift-placeholder';
      el.textContent = cfg.giftAddingText || 'Adicionando seu brinde...';
      entries.insertBefore(el, entries.firstChild);
    } catch (e) {}
  }
  function hideGiftPlaceholder() {
    try {
      document.querySelectorAll('.cx-gift-placeholder').forEach(function (el) { el.remove(); });
    } catch (e) {}
  }

  /* ---------- Confete (1x por sessão; rearma se cair abaixo da meta) ---------- */
  var KEY = 'cxConfettiFired';
  function confettiCheck() {
    try {
      var drawer = document.querySelector('[data-cx-drawer]');
      if (!drawer) return;
      var done = drawer.getAttribute('data-cx-metas-done') === 'true';
      if (!done) { sessionStorage.removeItem(KEY); return; }
      if (sessionStorage.getItem(KEY)) return;
      sessionStorage.setItem(KEY, '1');
      confetti(drawer);
    } catch (e) {}
  }

  function confetti(host) {
    var canvas = document.createElement('canvas');
    canvas.className = 'cx-confetti-canvas';
    host.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    canvas.width = host.clientWidth;
    canvas.height = host.clientHeight;
    var colors = ['#E87722', '#F59D55', '#000000', '#FFFFFF', '#EBEBEB'];
    var parts = [];
    for (var i = 0; i < 90; i++) {
      parts.push({
        x: Math.random() * canvas.width,
        y: -20 - Math.random() * canvas.height * 0.5,
        w: 5 + Math.random() * 5,
        h: 8 + Math.random() * 6,
        vy: 2 + Math.random() * 3,
        vx: -1 + Math.random() * 2,
        rot: Math.random() * Math.PI,
        vr: -0.1 + Math.random() * 0.2,
        color: colors[(Math.random() * colors.length) | 0]
      });
    }
    var start = Date.now();
    (function frame() {
      var t = Date.now() - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      parts.forEach(function (p) {
        p.y += p.vy; p.x += p.vx; p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      if (t < 2200) requestAnimationFrame(frame);
      else canvas.remove();
    })();
  }

  /* ---------- Upsell dinâmico (recomendações da Shopify) ----------
     Fonte 'related'/'complementary': busca /recommendations/products.json
     usando o produto pago de maior valor como referência e substitui a lista
     renderizada em Liquid (que fica como fallback se nada voltar). */
  var upsellGen = 0;

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || 'R$ {{amount_with_comma_separator}}';
    var val = (cents / 100).toFixed(2);
    var parts = val.split('.');
    var intBR = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var intUS = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return intUS + '.' + parts[1];
        case 'amount_with_comma_separator': return intBR + ',' + parts[1];
        case 'amount_no_decimals': return intUS;
        case 'amount_no_decimals_with_comma_separator': return intBR;
        default: return intBR + ',' + parts[1];
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function upsellCardHTML(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
    if (!variants.length) return '';
    var fv = variants[0];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var priceHTML = (fv.compare_at_price > fv.price ? '<s>' + formatMoney(fv.compare_at_price) + '</s> ' : '') +
      '<span class="jsPrice">' + formatMoney(fv.price) + '</span>';
    var selectHTML = '';
    if (variants.length > 1) {
      selectHTML = '<select class="cx-upsell__select" data-cx-upsell-select aria-label="Escolher variação de ' + esc(p.title) + '">' +
        variants.map(function (v) {
          var vImg = (v.featured_image && v.featured_image.src) || img;
          return '<option value="' + v.id + '" data-img="' + esc(vImg) + '" data-price="' + esc(formatMoney(v.price)) + '" data-compare="' +
            (v.compare_at_price > v.price ? esc(formatMoney(v.compare_at_price)) : '') + '">' + esc(v.title) + '</option>';
        }).join('') + '</select>';
    }
    return '<div class="cx-upsell__card" data-cx-upsell-card>' +
      '<div class="cx-upsell__img"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" data-cx-upsell-img></div>' +
      '<div class="cx-upsell__body">' +
        '<span class="cx-upsell__name">' + esc(p.title) + '</span>' +
        '<span class="cx-upsell__price" data-cx-upsell-price>' + priceHTML + '</span>' +
        selectHTML +
        '<button type="button" class="cx-upsell__add" data-cx-upsell-add data-variant-id="' + fv.id + '">' + esc(cfg.addText || 'Adicionar') + '</button>' +
      '</div></div>';
  }

  function enhanceUpsell() {
    try {
      var source = cfg.upsellSource || 'collection';
      if (source !== 'related' && source !== 'complementary') return;
      // vitrine travada na coleção da campanha: trocar por "relacionados" traria
      // produtos que não contam para o presente, que é o que queremos evitar
      if (document.querySelector('[data-cx-upsell-lock]')) return;
      var drawer = document.querySelector('[data-cx-drawer]');
      if (!drawer) return;
      var seed = parseInt(drawer.getAttribute('data-cx-seed-pid'), 10);
      if (!seed) return; // carrinho vazio ou só brindes: fica o fallback
      var cartPids = drawer.getAttribute('data-cx-cart-pids') || ',';
      var limit = cfg.upsellLimit || 3;
      var gen = ++upsellGen;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'recommendations/products.json?product_id=' + seed +
        '&limit=' + Math.min(limit + 6, 10) + '&intent=' + source;
      rawFetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (gen !== upsellGen) return; // resposta atrasada de um render antigo
          var giftPids = cfg.giftProductIds || [];
          var r1Pids = cfg.r1ProductIds || [];
          var prods = (data.products || []).filter(function (p) {
            if (cartPids.indexOf(',' + p.id + ',') !== -1) return false;
            if (giftPids.indexOf(p.id) !== -1) return false;
            // os clones de R$ 1 são produtos ocultos: nunca como recomendação
            if (r1Pids.indexOf(p.id) !== -1) return false;
            if (cfg.casePid && p.id === cfg.casePid) return false;
            return p.available !== false;
          }).slice(0, limit);
          if (!prods.length) return; // mantém o fallback da coleção
          var html = prods.map(upsellCardHTML).join('');
          if (!html) return;
          var wrap = document.querySelector('[data-cx-upsell-wrap]');
          var list = document.querySelector('[data-cx-upsell-list]');
          if (!wrap || !list) return;
          list.innerHTML = html;
          wrap.classList.remove('cx-upsell--empty');
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* ---------- Classe no body enquanto o drawer está aberto ----------
     Fallback do body:has() do CSS (esconde widgets flutuantes, ex.: bolinha
     de vídeo das coleções). O checkbox do drawer também é marcado via JS
     (sem evento change), por isso o clique global re-sincroniza. */
  function syncDrawerOpen() {
    try {
      var open = !!document.querySelector('[data-minicart-input]:checked');
      document.body.classList.toggle('cx-drawer-open', open);
    } catch (e) {}
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-minicart-input]')) syncDrawerOpen();
  });
  document.addEventListener('click', function () { setTimeout(syncDrawerOpen, 120); }, true);

  /* ---------- Guards de toque (iOS): rolar a lista não pode adicionar produto ---------- */
  var touchStart = null;
  var lastScroll = 0;
  document.addEventListener('touchstart', function (e) {
    var t = e.touches && e.touches[0];
    if (t) touchStart = { x: t.clientX, y: t.clientY };
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    var t = e.touches && e.touches[0];
    if (t && touchStart) {
      var dx = Math.abs(t.clientX - touchStart.x);
      var dy = Math.abs(t.clientY - touchStart.y);
      if (dx > 6 || dy > 6) touchStart.moved = true;
    }
  }, { passive: true });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.closest && e.target.closest('.cx-entries')) lastScroll = Date.now();
  }, { capture: true, passive: true });

  function touchOk() {
    if (touchStart && touchStart.moved) return false;
    if (Date.now() - lastScroll < 300) return false;
    return true;
  }

  /* ---------- Upsell (delegação: o DOM do drawer é substituído a cada render) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-cx-upsell-select]');
    if (!sel) return;
    try {
      var card = sel.closest('[data-cx-upsell-card]');
      var opt = sel.options[sel.selectedIndex];
      var btn = card.querySelector('[data-cx-upsell-add]');
      if (btn) btn.setAttribute('data-variant-id', opt.value);
      var img = card.querySelector('[data-cx-upsell-img]');
      if (img && opt.dataset.img) img.src = opt.dataset.img;
      var price = card.querySelector('[data-cx-upsell-price]');
      if (price && opt.dataset.price) {
        price.innerHTML = (opt.dataset.compare ? '<s>' + opt.dataset.compare + '</s> ' : '') +
          '<span class="jsPrice">' + opt.dataset.price + '</span>';
      }
    } catch (err) {}
  });

  /* ---------- Case: expandir/recolher (PDP e drawer) + toggle no drawer ---------- */
  document.addEventListener('click', function (e) {
    var exp = e.target.closest && e.target.closest('[data-cx-case-expand]');
    if (exp) {
      e.preventDefault();
      var box = exp.closest('[data-cx-case], [data-cx-case-cart]');
      var body = box && box.querySelector('[data-cx-case-body]');
      if (body) {
        var open = body.hasAttribute('hidden');
        if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
        exp.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  document.addEventListener('change', function (e) {
    var tgl = e.target.closest && e.target.closest('[data-cx-case-cart-toggle]');
    if (!tgl) return;
    try {
      var box = tgl.closest('[data-cx-case-cart]');
      var caseId = parseInt(box.getAttribute('data-case-variant'), 10);
      var key = box.getAttribute('data-case-key');
      tgl.disabled = true; // o re-render do drawer substitui o DOM em seguida
      if (tgl.checked) {
        window.fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: caseId, quantity: 1 }] })
        }).catch(function () { tgl.disabled = false; tgl.checked = false; });
      } else if (key) {
        window.fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).catch(function () { tgl.disabled = false; tgl.checked = true; });
      }
    } catch (err) {}
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cx-upsell-add]');
    if (btn) {
      e.preventDefault();
      if (!touchOk() || btn.disabled) return;
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      btn.disabled = true;
      btn.textContent = cfg.addingText || 'Adicionando...';
      // usa o fetch interceptado de propósito: o add agenda o reconcile/refresh
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = cfg.addText || 'Adicionar';
      });
      return;
    }

    var checkout = e.target.closest && e.target.closest('[data-cx-checkout]');
    if (checkout) {
      e.preventDefault();
      if (checkout.disabled) return;
      checkout.disabled = true;
      handoffCheckout().catch(function () {
        checkout.disabled = false;
        window.location.href = '/checkout';
      });
    }
  });

  /* ---------- Checkout (Yampi) ---------- */
  function handoffCheckout() {
    var pre = Promise.resolve();
    if (cfg.giftEnabled && cfg.giftRemoveBeforeCheckout && cfg.gifts && cfg.gifts.length) {
      var giftIds = cfg.gifts.map(function (g) { return g.id; });
      pre = rawFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var lines = (cart.items || []).filter(function (i) { return giftIds.indexOf(i.variant_id) !== -1; });
          return lines.reduce(function (chain, line) {
            return chain.then(function () { return changeGift(line.key, 0); });
          }, Promise.resolve());
        })
        .catch(function () {});
    }
    // Última barreira antes da cobrança: se o cliente perdeu o direito ao
    // óculos de R$ 1, a Yampi cobraria o preço cheio. Tira do carrinho.
    return pre.then(function () {
      try {
        if (window.EthosR1 && typeof window.EthosR1.beforeCheckout === 'function') {
          return Promise.resolve(window.EthosR1.beforeCheckout()).catch(function () {});
        }
      } catch (e) {}
      return null;
    }).then(function () {
      if (typeof window.yampiClick === 'function') return window.yampiClick();
      window.location.href = '/checkout';
    });
  }

  /* ---------- Estado inicial (página carregada com carrinho já qualificado) ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();

/* ==========================================================================
   Envio prioritário (taxa opt-out) — IIFE separada de propósito.
   Vive fora do bloco acima pra não poder derrubar o carrinho: se algo aqui
   falhar, drawer/case/brinde seguem funcionando. Lê tudo de data-attributes
   do drawer (nada no <head>, nada em window.EthosCartConfig).

   Regras: pré-marcado, entra sozinho quando há produto de verdade no carrinho;
   a recusa fica no atributo cx_priority='off' senão a taxa voltaria no próximo
   add; some junto com o último produto pra não sobrar taxa órfã.
   ========================================================================== */
(function () {
  'use strict';

  var rawFetch = window.fetch.bind(window);
  var busy = false;

  function drawer() { return document.querySelector('[data-cx-drawer]'); }

  function readState() {
    var d = drawer();
    if (!d) return null;
    var vid = parseInt(d.getAttribute('data-cx-prio-variant'), 10) || 0;
    if (!vid) return null;
    return {
      variant: vid,
      realCount: parseInt(d.getAttribute('data-cx-prio-real-count'), 10) || 0,
      declined: d.getAttribute('data-cx-prio-declined') === '1',
      preselected: d.getAttribute('data-cx-prio-preselected') !== '0',
      lineKey: d.getAttribute('data-cx-prio-line-key') || '',
      lineQty: parseInt(d.getAttribute('data-cx-prio-line-qty'), 10) || 0
    };
  }

  function post(url, payload) {
    return rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  // usa o fetch interceptado (window.fetch) de propósito: agenda o re-render do drawer
  function postLive(url, payload) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  /* Roda depois de cada re-render do drawer: o Liquid já calculou tudo. */
  function sync() {
    if (busy) return;
    var s = readState();
    if (!s) return;
    try {
      if (!s.realCount && s.lineKey) { // taxa órfã: carrinho sem produto de verdade
        busy = true;
        postLive('/cart/change.js', { id: s.lineKey, quantity: 0 })
          .catch(function () {}).then(function () { busy = false; });
        return;
      }
      if (!s.realCount || s.declined) return;
      if (!s.preselected) return; // opt-in: só entra se o cliente marcar
      if (!s.lineKey) { // pré-marcado: entra sozinho
        busy = true;
        postLive('/cart/add.js', { items: [{ id: s.variant, quantity: 1 }] })
          .catch(function () {}).then(function () { busy = false; });
        return;
      }
      if (s.lineQty !== 1) { // alguém duplicou a linha
        busy = true;
        postLive('/cart/change.js', { id: s.lineKey, quantity: 1 })
          .catch(function () {}).then(function () { busy = false; });
      }
    } catch (e) { busy = false; }
  }

  /* Expandir/recolher a descrição */
  document.addEventListener('click', function (e) {
    try {
      var exp = e.target.closest && e.target.closest('[data-cx-prio-expand]');
      if (!exp) return;
      e.preventDefault();
      var box = exp.closest('[data-cx-prio]');
      var body = box && box.querySelector('[data-cx-prio-body]');
      if (!body) return;
      var abrir = body.hasAttribute('hidden');
      if (abrir) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
      exp.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    } catch (err) {}
  });

  /* Checkbox: grava a escolha ANTES de mexer no item, pra um sync concorrente
     já ler o valor novo e não desfazer o que o cliente pediu */
  document.addEventListener('change', function (e) {
    var tgl = e.target.closest && e.target.closest('[data-cx-prio-toggle]');
    if (!tgl) return;
    var s = readState();
    if (!s) return;
    var on = tgl.checked;
    tgl.disabled = true; // o re-render do drawer troca o DOM em seguida
    busy = true;
    post('/cart/update.js', { attributes: { cx_priority: on ? 'on' : 'off' } })
      .then(function () {
        if (on) return postLive('/cart/add.js', { items: [{ id: s.variant, quantity: 1 }] });
        if (s.lineKey) return postLive('/cart/change.js', { id: s.lineKey, quantity: 0 });
      })
      .catch(function () { tgl.disabled = false; tgl.checked = !on; })
      .then(function () { busy = false; });
  });

  /* O drawer é re-renderizado inteiro a cada mudança: observa e reage. */
  function watch() {
    try {
      var host = document.querySelector('[data-product-list]') || document.body;
      new MutationObserver(function () {
        clearTimeout(watch._t);
        watch._t = setTimeout(sync, 300);
      }).observe(host, { childList: true, subtree: true });
    } catch (e) {}
    setTimeout(sync, 1200); // primeiro load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/* ==========================================================================
   5 Anos Ethos — óculos por R$ 1. IIFE separada de propósito (mesmo motivo do
   envio prioritário): se algo aqui falhar, drawer/brinde/case seguem de pé.

   Quem cobra R$ 1,00 é a promoção "Compre X, Leve Y" da Yampi — aqui mora só
   a experiência. Daí a responsabilidade crítica deste arquivo:

     a Yampi só aplica o desconto se o carrinho tiver os 2 óculos participantes.
     Se o cliente escolher o brinde e depois remover um óculos, a promoção
     deixa de valer e ele seria COBRADO PELO PREÇO CHEIO. Por isso o brinde é
     removido automaticamente quando o direito se perde, e revalidado uma
     última vez antes do handoff para o checkout.

   Entra no pipeline pelo hook window.EthosR1.reconcile (ver r1Hook acima).
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.EthosCartConfig || {};
  if (!cfg.r1Enabled) return;

  var raw = window.EthosCartRaw || window.fetch.bind(window);
  var SKEY = 'cxR1PickerShown';
  var MIN = cfg.r1MinQty || 2;
  var r1Variants = cfg.r1VariantIds || [];
  var eligibleIds = cfg.r1EligibleIds || [];
  var giftIds = (cfg.gifts || []).map(function (g) { return g.id; });

  if (!r1Variants.length) return;

  function isR1Line(item) {
    return r1Variants.indexOf(item.variant_id) !== -1;
  }

  function r1Lines(cart) {
    return (cart.items || []).filter(isR1Line);
  }

  /* ---------- Elegibilidade ----------
     /cart.js não traz as coleções do produto, então a conta é feita com a
     lista de ids que o Liquid emitiu. Se a coleção passou de 50 produtos
     (collection.products trunca fora de um paginate), a lista está incompleta
     e aí quem manda é o cálculo do Liquid, que viaja no data-attribute. */
  function eligibleUnits(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (isR1Line(it)) return;                                  // o próprio brinde não conta
      if (giftIds.indexOf(it.variant_id) !== -1) return;          // brinde de R$ 0 não conta
      if (cfg.casePid && it.product_id === cfg.casePid) return;   // case não é óculos
      if (eligibleIds.indexOf(it.product_id) !== -1) n += it.quantity;
    });
    return n;
  }

  function unlockedNow(cart) {
    if (cfg.r1EligibleCapped) {
      var el = document.querySelector('[data-cx-r1-unlocked]');
      if (el) return el.getAttribute('data-cx-r1-unlocked') === '1';
    }
    return eligibleUnits(cart) >= MIN;
  }

  function change(key, qty) {
    return raw('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return true; }).catch(function () { return false; });
  }

  function runSeq(ops) {
    // em sequência: mutações concorrentes no carrinho se atropelam
    return ops.reduce(function (chain, op) {
      return chain.then(op).catch(function () {});
    }, Promise.resolve());
  }

  /* ---------- Aviso ---------- */
  var toastTimer = null;
  function showToast(msg) {
    if (!msg) return;
    try {
      var old = document.querySelector('.cx-r1-toast');
      if (old) old.remove();
      var el = document.createElement('div');
      el.className = 'cx-r1-toast';
      el.setAttribute('role', 'status');
      el.textContent = msg;
      document.body.appendChild(el);
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { try { el.remove(); } catch (e) {} }, 6000);
    } catch (e) {}
  }

  /* ---------- Popup ---------- */
  var pickerHTML = null;
  var pickerLoading = null;

  function loadPicker() {
    if (pickerHTML) return Promise.resolve(pickerHTML);
    if (pickerLoading) return pickerLoading;
    pickerLoading = raw('/?section_id=api__r1-picker', { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        if (!t || t.indexOf('data-cx-r1-picker') === -1) throw new Error('picker vazio');
        pickerHTML = t;
        return t;
      })
      .catch(function () { pickerLoading = null; return null; });
    return pickerLoading;
  }

  function modalEl() { return document.getElementById('quickbuy__modal'); }

  function resetSteps(root) {
    try {
      var models = root.querySelector('[data-cx-r1-step="models"]');
      var colors = root.querySelector('[data-cx-r1-step="colors"]');
      if (models) models.hidden = false;
      if (colors) colors.hidden = true;
      root.querySelectorAll('[data-cx-r1-panel]').forEach(function (p) { p.hidden = true; });
      root.querySelectorAll('.cx-r1__swatch').forEach(function (b) { b.classList.remove('is-adding'); });
    } catch (e) {}
  }

  function openPicker() {
    var modal = modalEl();
    if (!modal) return;
    var content = modal.querySelector('.content');
    if (!content) return;
    loadPicker().then(function (html) {
      if (!html) return;
      try {
        content.innerHTML = html;
        resetSteps(content);
        modal.classList.add('cx-r1-open');
        modal.style.display = 'flex';
        modal.style.alignItems = 'center';
        modal.style.justifyContent = 'center';
      } catch (e) {}
    });
  }

  function closePicker() {
    try {
      var modal = modalEl();
      if (!modal) return;
      modal.style.display = 'none';
      modal.classList.remove('cx-r1-open');
    } catch (e) {}
  }

  /* ---------- Escolher / trocar o modelo ---------- */
  function addR1(variantId, btn) {
    if (btn) btn.classList.add('is-adding');
    return raw('/cart.js', { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // troca de modelo: o brinde anterior sai ANTES (com o fetch cru, sem
        // reagendar) — deixar para o reconcile removeria a escolha nova, que
        // é a última da lista
        return runSeq(r1Lines(cart).map(function (l) {
          return function () { return change(l.key, 0); };
        }));
      })
      .then(function () {
        closePicker();
        // de propósito no fetch interceptado: agenda o reconcile e o re-render
        return window.fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-adding');
      });
  }

  /* ---------- Delegação no document (o DOM do drawer é descartável) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    try {
      // abrir (faixa do carrinho ou "trocar modelo" na linha)
      if (e.target.closest('[data-cx-r1-open]')) {
        e.preventDefault();
        openPicker();
        return;
      }

      var pick = e.target.closest('[data-cx-r1-pick]');
      if (pick) {
        e.preventDefault();
        var single = pick.getAttribute('data-cx-r1-single');
        if (single) { addR1(parseInt(single, 10), pick); return; }   // cor única: pula o passo 2
        var root = pick.closest('[data-cx-r1-picker]');
        if (!root) return;
        var pid = pick.getAttribute('data-cx-r1-pick');
        root.querySelectorAll('[data-cx-r1-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-cx-r1-panel') !== pid;
        });
        var models = root.querySelector('[data-cx-r1-step="models"]');
        var colors = root.querySelector('[data-cx-r1-step="colors"]');
        if (models) models.hidden = true;
        if (colors) colors.hidden = false;
        return;
      }

      if (e.target.closest('[data-cx-r1-back]')) {
        e.preventDefault();
        var r = e.target.closest('[data-cx-r1-picker]');
        if (r) resetSteps(r);
        return;
      }

      var add = e.target.closest('[data-cx-r1-add]');
      if (add) {
        e.preventDefault();
        if (add.classList.contains('is-adding')) return;
        var vid = parseInt(add.getAttribute('data-cx-r1-add'), 10);
        if (vid) addR1(vid, add);
        return;
      }

      // fechar pelo overlay ou pelo X: o closeModal global cuida do display,
      // aqui só limpamos a classe para não vazar estilo no quickbuy do Booster
      if (e.target.closest('#quickbuy__modal.cx-r1-open')) {
        if (e.target.closest('.overlay') || e.target.closest('.cx-r1__close')) {
          setTimeout(function () {
            var m = modalEl();
            if (m) m.classList.remove('cx-r1-open');
          }, 0);
        }
      }
    } catch (err) {}
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = modalEl();
      if (m && m.classList.contains('cx-r1-open')) closePicker();
    }
  });

  /* ---------- Reconcile (chamado pelo pipeline principal) ---------- */
  function reconcileR1(cart) {
    var ops = [];
    var lines = r1Lines(cart);
    var unlocked = unlockedNow(cart);

    if (!unlocked) {
      if (lines.length) {
        // A TRAVA: sem os 2 óculos a Yampi não aplica o desconto e o cliente
        // pagaria o preço cheio. Tira do carrinho e explica.
        lines.forEach(function (l) { ops.push(function () { return change(l.key, 0); }); });
        showToast(cfg.r1RemovedText);
      }
      // Fecha mesmo sem brinde no carrinho: se o cliente deixou o popup aberto
      // e removeu um óculos, ele estaria escolhendo um presente a que não tem
      // mais direito — e o clique seria desfeito logo em seguida.
      closePicker();
      // rearma o auto-abrir: desbloquear de novo volta a merecer o popup
      try { sessionStorage.removeItem(SKEY); } catch (e) {}
    } else {
      if (lines.length > 1) {
        // Duplicata só aparece em estado anômalo (duas abas, corrida, add por
        // fora): o addR1 limpa as linhas antigas antes de inserir a nova. A
        // ordem de /cart.js NÃO segue a ordem de adição (testado: o item
        // adicionado por último veio listado primeiro), então não dá para
        // deduzir a escolha mais recente — o que importa é sobrar exatamente
        // uma, de forma determinística e igual à que o Liquid exibe. O cliente
        // corrige em um clique no "Trocar modelo".
        lines.slice(0, -1).forEach(function (l) { ops.push(function () { return change(l.key, 0); }); });
      }
      var keep = lines[lines.length - 1];
      if (keep && keep.quantity !== 1) {
        ops.push(function () { return change(keep.key, 1); });  // 1 brinde por pedido
      }
      if (!lines.length && cfg.r1AutoOpen) {
        var shown = false;
        try { shown = sessionStorage.getItem(SKEY) === '1'; } catch (e) {}
        if (!shown) {
          try { sessionStorage.setItem(SKEY, '1'); } catch (e) {}
          setTimeout(openPicker, 600);  // deixa o drawer abrir primeiro
        }
      }
      loadPicker();  // pré-carrega: a escolha não deve esperar rede
    }

    return runSeq(ops);
  }

  /* ---------- Última barreira antes do checkout Yampi ---------- */
  function beforeCheckout() {
    return raw('/cart.js', { headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = r1Lines(cart);
        if (!lines.length || unlockedNow(cart)) return null;
        showToast(cfg.r1RemovedText);
        return runSeq(lines.map(function (l) {
          return function () { return change(l.key, 0); };
        }));
      })
      .catch(function () {});
  }

  window.EthosR1 = { reconcile: reconcileR1, beforeCheckout: beforeCheckout, open: openPicker };
})();
